import { render, staticRenderFns } from "./Siparis.vue?vue&type=template&id=75add948&scoped=true&"
import script from "./Siparis.vue?vue&type=script&lang=js&"
export * from "./Siparis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75add948",
  null
  
)

export default component.exports